import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState: ContainerCollectionState = {
    formSearch: {},
    sort: 'fill_ratio:desc'
};

export const containerCollectionSlice = createSlice({
    name: 'containerCollection',
    initialState,
    reducers: {
        setFormSearch: (state, action: PayloadAction<ICollectionSearch>) => {
            state.formSearch = action.payload;
        },
        setSort: (state, action: PayloadAction<string | undefined>) => {
            state.sort = action.payload;
        },
    },
});

export const {
    setFormSearch,
    setSort,
} = containerCollectionSlice.actions;

export default containerCollectionSlice.reducer;
